import React from 'react';
import DataTables from 'components/dataTables';

import PopupWindow from 'components/ModalPopup';

import TableCustomHeader from 'components/dataTables/tableCustomHeader';
import { connect } from 'react-redux';
import { CampaignAction } from 'redux/actions';
import { DateFormat, checkPermissions } from 'hooks';
import { MdModeEdit } from 'react-icons/md';
import AddChargeForm from './addCharge';
const CampaignCharges = (props) => {
    const [open, setOpen] = React.useState(false);
    const [pagination, setPagination] = React.useState({ page: 0, page_limit: 10 });
    const [order, setOrder] = React.useState({ order_by: `created_at`, direction: 'desc' });

    let [selectedCharge, setSelectedCharge] = React.useState({});

    const columns = () => {
        const cols = [
            { name: "id", label: "Id" },
            { name: "goal", label: "Goal" },
            { name: "value", label: "Charges" },
            { name: "updated_at", label: "Last Updated" },
            { name: "action", label: "Action" }
        ];
        return cols.map((column, index) => {
            return {
                label: column.label,
                name: column.name,
                options: {
                    display: (column.name === 'user_id') ? false : true,
                    customHeadRender: (columnMeta, updateDirection) => {
                        return <TableCustomHeader key={index} itemkey={index} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                    },
                    customBodyRender: (value, tableMeta, updateValue) => {

                        return (column.name === 'created_at' || column.name === 'updated_at') ? DateFormat(value) :
                            (column.name === 'action') ? <div>
                                {checkPermissions(props.loginData, 'edit_group') ?
                                    <MdModeEdit onClick={() => handleEdit(tableMeta.rowData)} size={25} style={{ borderRadius: 5, border: '1px solid', cursor: 'pointer', color: '#00aee4', marginLeft: 10 }} />
                                    : <MdModeEdit className={'disabled'} size={25} style={{ borderRadius: 5, border: '1px solid', cursor: 'pointer', color: '#00aee4', marginLeft: 10 }} />
                                }

                            </div>
                                : value
                    },
                }
            }
        })
    }

    React.useEffect(() => {
        let payload = {
            page: pagination.page,
            page_limit: pagination.page_limit,
            order_by: order.order_by,
            direction: order.direction
        };
        props.getCampaignCharges(payload);
    }, [pagination, order])

    React.useEffect(() => {
        if (props.chargesUpdated) {
            let payload = {
                page: pagination.page,
                page_limit: pagination.page_limit,
                order_by: order.order_by,
                direction: order.direction
            };
            props.getCampaignCharges(payload);
            setOpen(false);
        }
    }, [props.chargesUpdated])


    const handleEdit = (rowData) => {
        setSelectedCharge(rowData)
        setOpen(true);
    }

    const handlePopup = (status) => {
        setOpen(status);
        setSelectedCharge({});
    }
    return (
        <div>
            <PopupWindow
                hideButton={!checkPermissions(props.loginData, 'add_group')}
                handlePopup={handlePopup}
                openWindow={open}
                title={selectedCharge && selectedCharge[0] ?'Edit Charge':'Add New Charge'}
                btnClass={'add-new-charge'}
                launchButtonText={'Add New Charge'} buttonStyle={{ display: 'block', marginLeft: 'auto', marginBottom: '10px' }}>
                <AddChargeForm selectedCharge={selectedCharge} />
            </PopupWindow>
            <DataTables data={props.charges} columns={columns()} options={{
                tableId: 'datatable',
                filterType: 'checkbox',
                search: false,
                responsive: "simple",
                filter: false,
                download: false,
                print: false,
                selectableRows: 'none',
                viewColumns: false,
                count: props.totalCount,
                serverSide: (props.serverSide !== undefined) ? props.serverSide : true,
                page: pagination.page,
                rowsPerPage: pagination.page_limit,
                onColumnSortChange: (changedColumn) => {
                    setOrder({
                        order_by: changedColumn,
                        direction: (order.direction === 'asc') ? 'desc' : 'asc'
                    })
                },
                onTableChange: (action, tableState) => {
                    switch (action) {
                        case 'changePage':
                            setPagination({
                                page_limit: pagination.page_limit,
                                page: tableState.page
                            })
                            break;
                        case 'changeRowsPerPage':
                            setPagination({
                                page_limit: tableState.rowsPerPage,
                                page: 0,
                            })
                            break;
                        default:
                            break
                    }
                }
            }} />
        </div>
    );
}

const mapStateToProps = (state) => ({
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    charges: (state.campaign &&
        state.campaign.charges &&
        state.campaign.charges.data) ? state.campaign.charges.data : [],
    totalCount: (state.campaign && state.campaign.charges &&
        state.campaign.charges.totalCount) ? state.campaign.charges.totalCount : 0,
    chargesUpdated: (state.campaign && state.campaign.chargesUpdated) ? state.campaign.chargesUpdated : undefined,
});

const mapDispatchToProps = (dispatch) => ({
    getCampaignCharges: (payload) => dispatch(CampaignAction.getCampaignCharges(payload)),
    saveCampaignCharges: (payload) => dispatch(CampaignAction.saveCampaignCharges(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CampaignCharges);
